import { create } from 'zustand';
import authFetch from '../utils/authFetch';

const useOrgStore = create((set, get) => ({
  org: null,
  loading: false,
  _orgPollTimer: null,

  fetchOrg: async () => {
    set({ loading: true });
    try {
      const org = await authFetch('/api/v1/org/me');
      set({ org });
      return org;
    } finally {
      set({ loading: false });
    }
  },

  uploadLogo: async (file) => {
    const form = new FormData();
    form.append('logo', file);
    const token = localStorage.getItem('token');
    const res = await fetch('/api/v1/org/logo', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: form,
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || 'Falha no upload');
    set({ org: data.data });
    return data.data;
  },

  deleteLogo: async () => {
    const org = await authFetch('/api/v1/org/logo', { method: 'DELETE' });
    set({ org });
    return org;
  },

  uploadLoginLogo: async (file) => {
    const form = new FormData();
    form.append('login_logo', file);
    const token = localStorage.getItem('token');
    const res = await fetch('/api/v1/org/login-logo', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: form,
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || 'Falha no upload');
    set({ org: data.data });
    return data.data;
  },

  deleteLoginLogo: async () => {
    const org = await authFetch('/api/v1/org/login-logo', { method: 'DELETE' });
    set({ org });
    return org;
  },

  uploadFavicon: async (file) => {
    const form = new FormData();
    form.append('favicon', file);
    const token = localStorage.getItem('token');
    const res = await fetch('/api/v1/org/favicon', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: form,
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || 'Falha no upload');
    set({ org: data.data });
    return data.data;
  },

  deleteFavicon: async () => {
    const org = await authFetch('/api/v1/org/favicon', { method: 'DELETE' });
    set({ org });
    return org;
  },

  patchOrg: async (fields) => {
    const token = localStorage.getItem('token');
    const res = await fetch('/api/v1/org/me', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(fields),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || 'Erro ao salvar');
    set({ org: data.data });
    return data.data;
  },

  updateOrgConfig: async (configPatch) => {
    const { org } = get();
    const currentConfig = org?.config ?? {};
    const merged = { ...currentConfig, ...configPatch };
    const token = localStorage.getItem('token');
    const res = await fetch('/api/v1/org/me', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ config: merged }),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || 'Erro ao salvar configuração');
    set({ org: data.data });
    return data.data;
  },

  clearOrg: () => set({ org: null }),

  startOrgPolling: (intervalMs = 30000) => {
    get().stopOrgPolling();
    const tick = () => { get().fetchOrg().catch(() => {}); };
    const timer = setInterval(tick, intervalMs);
    set({ _orgPollTimer: timer });
  },

  stopOrgPolling: () => {
    const { _orgPollTimer } = get();
    if (_orgPollTimer) { clearInterval(_orgPollTimer); set({ _orgPollTimer: null }); }
  },
}));

export default useOrgStore;
